// extracted by mini-css-extract-plugin
export default {"wrapper":"sU-z","availablePromoMessagesLabel":"tU-z","promoMessageList":"uU-z","promoMessage":"vU-z","appliedPromoMessage":"wU-z","promoMessageAmount":"xU-z"};